import React, { FC } from 'react';
import { useTranslator } from '$hooks';

export const BotNeedHelpDescription: FC<{ link: string }> = ({ link }) => {
  const t = useTranslator();

  return (
    <>
      {t('tg_bot_need_help_text_link_1')}{' '}
      <a href={link} target="_blank" rel="noreferrer">
        {t('tg_bot_need_help_text_link_2')}
      </a>
    </>
  );
};
